import React from "react";
import FacultyProfilePage from "../components/FacultyProfile";
import Navbar from "../components/Navbar";

const TasneemZakariaMehta = () => {
    return (
        <>
            <Navbar />
            <FacultyProfilePage
                name="Tasneem Zakaria Mehta"
                image="/Faculty-seasons-Cover.jpg"
                profileImage="/Tasneem-Zakaria-Mehta-2.jpg"
                bio="Tasneem Zakaria Mehta is an art historian, curator, designer, and cultural activist. She is the Managing Trustee and Honorary Director of Dr. Bhau Daji Lad Museum, Mumbai, and former Vice Chairman of INTACH. Ms. Mehta is a Vice President of the International Council of the MoMA, New York."
            />
        </>
    );
};

export default TasneemZakariaMehta;